<template>
  <div class="pa-10">
    <PreferredSkillsDataTable />
  </div>
</template>

<script>
import PreferredSkillsDataTable from "@/components/Utils/PreferredSkillsDataTable.vue";
export default {
  components: {
    PreferredSkillsDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
